import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "./slice/authSlice";
import { toast } from "react-toastify";

const AutoLogout = () => {
  const navigate = useNavigate();
  const logoutTimer = useRef(null);
  const warningTimer = useRef(null);
  const dispatch = useDispatch();

  // Function to log the user out
  const logoutUser = async () => {
    toast.dismiss(); // Dismiss any toast
    if (localStorage.getItem("users") && localStorage.getItem("accessToken")) {
      localStorage.setItem("accessToken", "");
      localStorage.setItem("users", "");
      localStorage.clear();
      await dispatch(logout());
      navigate("/?registerModal=true");
    }
  };

  // Function to reset the inactivity timer
  const resetTimer = () => {
    if (logoutTimer.current) clearTimeout(logoutTimer.current);
    if (warningTimer.current) clearTimeout(warningTimer.current);

    // Show warning after 55 minutes (3300000 ms)
    warningTimer.current = setTimeout(() => {
      toast.warn("You will be logged out in 5 minutes due to inactivity!");
    }, 3300000); // 55 minutes

    // Logout after 60 minutes (3600000 ms)
    logoutTimer.current = setTimeout(logoutUser, 3600000);
  };

  useEffect(() => {
    resetTimer();

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    window.addEventListener("scroll", resetTimer);

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      clearTimeout(logoutTimer.current);
      clearTimeout(warningTimer.current);
    };
  }, []);

  return null;
};

export default AutoLogout;
